import React from 'react';
import { DonorRequest } from '../../models/DonorRequest';
import { METHOD_TEXTS } from '../../consts';
import { Dispatch, SetStateAction } from 'react';

interface DonorRequestProps {
  donorRequest: DonorRequest | null;
  setDonorRequest: Dispatch<SetStateAction<DonorRequest | null>>;
}

const Request = (props: DonorRequestProps) => {
  const { donorRequest, setDonorRequest } = props;

  const methodOptions = Object.entries(METHOD_TEXTS);

  const handleMethodChange = (code: string, checked: boolean) => {
    setDonorRequest(prev => {
      if (!prev) return prev;
      const current = prev.methods || [];
      const newMethods = checked
        ? [...current, code]
        : current.filter(m => m !== code);
      return prev.set('methods', newMethods);
    });
  };

  return (
    <>
      <h3 className="sub_title">精子提供について</h3>
      <div className="form">
        <dl className="graf_list">
          <dt>提供方法</dt>
          <dd>
            <span className="wpcf7-form-control-wrap checkbox-content">
              <span className="wpcf7-form-control wpcf7-checkbox wpcf7-validates-as-required">
                {methodOptions.map(([code, label], idx) => (
                  <span key={code} className={`wpcf7-list-item${idx === 0 ? ' first' : ''}`}>
                    <label>
                      <input
                        type="checkbox"
                        name="checkbox-content[]"
                        value={label}
                        checked={donorRequest?.methods?.includes(code) || false}
                        onChange={e => handleMethodChange(code, e.target.checked)}
                      />
                      <span className="wpcf7-list-item-label">{label}</span>
                    </label>
                  </span>
                ))}
              </span>
            </span>
          </dd>
          <dt>交通費・宿泊代</dt>
          <dd>
            <div className="select select01">
              <select
                value={donorRequest?.travelExpenses || ''}
                onChange={e => setDonorRequest(prev => prev ? prev.set('travelExpenses', e.target.value) : null)}
              >
                <option value="">選択してください</option>
                <option value="DONOR_PAYS">ドナー負担</option>
                <option value="DONEE_PAYS">ドニー負担</option>
                <option value="SPLIT">割り勘</option>
              </select>
            </div>
          </dd>
          <dt>身元の開示</dt>
          <dd>
            <div className="select select01">
              <select
                value={donorRequest?.identityDisclosure || ''}
                onChange={e => setDonorRequest(prev => prev ? prev.set('identityDisclosure', e.target.value) : null)}
              >
                <option value="">選択してください</option>
                <option value="AVAILABLE">可</option>
                <option value="UNAVAILABLE">不可（匿名）</option>
              </select>
            </div>
          </dd>
          <dt>証明書の提示可否</dt>
          <dd>
            <div className="select select01">
              <select
                value={donorRequest?.certificatePresentation || ''}
                onChange={e => setDonorRequest(prev => prev ? prev.set('certificatePresentation', e.target.value) : null)}
              >
                <option value="">選択してください</option>
                <option value="AVAILABLE">可</option>
                <option value="UNAVAILABLE">不可</option>
              </select>
            </div>
          </dd>
          <dt>出自を知る権利</dt>
          <dd>
            <div className="select select01">
              <select
                value={donorRequest?.originRight || ''}
                onChange={e => setDonorRequest(prev => prev ? prev.set('originRight', e.target.value) : null)}
              >
                <option value="">選択してください</option>
                <option value="AVAILABLE">対応可</option>
                <option value="UNAVAILABLE">対応不可</option>
              </select>
            </div>
          </dd>
        </dl>
      </div>
    </>
  );
}

export default Request;
